export const startDate = '2024-02-29T17:53:49.281Z';
export const drones = 111;
